import { render, staticRenderFns } from "./PropertiesTableRow.vue?vue&type=template&id=060aabec&scoped=true&"
import script from "./PropertiesTableRow.vue?vue&type=script&lang=js&"
export * from "./PropertiesTableRow.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesTableRow.vue?vue&type=style&index=0&id=060aabec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060aabec",
  null
  
)

export default component.exports